// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"93107478","882":"7522ee4c"}[chunkId] + ".chunk.js";
};